import { makeGetRequest } from 'lib/axios';

export type DevSwitchableUser = {
  _id: string;
  name: string;
  email: string;
  type: string;
};

const getDevSwitchableUsers = async (
  search = '',
): Promise<DevSwitchableUser[]> => {
  const params = new URLSearchParams();
  if (search.trim()) {
    params.set('search', search.trim());
    params.set('limit', '50');
  }
  const query = params.toString();
  const url = query ? `/dev/users?${query}` : '/dev/users';
  const response = await makeGetRequest(url);
  return response.data.payload;
};

export default getDevSwitchableUsers;
